import React, { useState } from 'react';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';

import * as S from './style';
import useSubmitForm from './useSubmitForm';
import useSchema from '../../schema/useSchema';
import { Button, ButtonWrapper } from '../form-components/style';
import { postMessage } from '../../utils';
import { FormProvider } from '../../contexts/form-context';

import ContestDetails from './contest-details';

const ContestForm = () => {
  const { t } = useTranslation();
  const { Schema } = useSchema();
  const { submitForm } = useSubmitForm();
  const [showOverlay, setShowOverlay] = useState(false);

  setTimeout(window.onresize);

  return (
    <React.Fragment>
      {showOverlay ? <S.Overlay /> : null}
      <h1>{t('Header_Copy')}</h1>
      <Formik
        validateOnBlur={true}
        validationSchema={Schema.getSchema()}
        initialValues={Schema.getInitialValues()}
        onSubmit={async (values) => {
          setShowOverlay(true);
          postMessage('track', { action: 'CTA_SUBMIT' });
          await submitForm(values).then(() => setShowOverlay(false));
        }}
      >
        {({ errors, touched, values, validateForm }) => (
          <FormProvider
            value={{
              errors,
              values,
              touched,
            }}
          >
            <S.ContestForm>
              <ContestDetails fields={Schema.contestFields} />
              <ButtonWrapper>
                <Button
                  className="submit"
                  type="submit"
                  onClick={async () => {
                    validateForm();
                  }}
                >
                  {t('Submit_button')}
                </Button>
              </ButtonWrapper>
            </S.ContestForm>
          </FormProvider>
        )}
      </Formik>
    </React.Fragment>
  );
};

export default ContestForm;
